import React from 'react';
import ReactDOM from 'react-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { HashRouter as Router, Route } from "react-router-dom";
import { API_PRO } from './env';
/* Modulos */
	import Header from './partials/Header';
	import Menu from './partials/Menu';
	// import Footer from './partials/Footer';
	import Dashboard from './Dashboard';
	import Productos from './Productos';
	import Usuarios from './Usuarios';
	import Sucursales from './Sucursales';
	import Reportes from './Reportes';
	import Rgeneral from './ReporteGeneral';
	import Descuentos from './Descuentos';
	import Inventarioadmin from './Inventarioadmin';
	import Inventario from './Inventario';
	import ReporteDeCajas from './ReporteDeCajas';
	import Login from './Login';
	// import Gastos from './Gastos';
/* Modulos */

window.$isDecimal = function(valor){
	var RE = /^\d*(\.\d{1})?\d{0,1}$/;
	if (RE.test(valor)) {
		return true;
	} else {
		return false;
	}
}

window.$api = API_PRO;

window.$fmoney = function(amount, decimals) {
	amount += ''; // por si pasan un numero en vez de un string
	amount = parseFloat(amount.replace(/[^0-9.]/g, '')); // elimino cualquier cosa que no sea numero o punto
	decimals = decimals || 0; // por si la variable no fue fue pasada
	// si no es un numero o es igual a cero retorno el mismo cero
	if (isNaN(amount) || amount === 0){
	   	return parseFloat(0).toFixed(decimals);
	}
	// si es mayor o menor que cero retorno el valor formateado como numero
	amount = '' + amount.toFixed(decimals);
	var amount_parts = amount.split('.'),
	regexp = /(\d+)(\d{3})/;

	while (regexp.test(amount_parts[0])){
		amount_parts[0] = amount_parts[0].replace(regexp, '$1,$2');
	}
	return '$'+amount_parts.join('.');
}
window.$getFormData = (data) => {
	var formData = new FormData();
	let keys = Object.keys(data);
	let item= 0;
	for(let k in data){
		formData.append(keys[item], data[k]);
		item++;
	}
	return formData;
}
window.$created_at = () => {
	let fecha = new Date();
	let month = fecha.getMonth() + Number(1);
	month = month < 10 ? '0'+month : month;
	let today = fecha.getFullYear()+'-'+month+'-'+fecha.getDate();
	today = today +' '+fecha.getHours() + ':' + fecha.getMinutes() + ':' + fecha.getSeconds();
	return today;
}
window.$parseDate = date => {
	let month = date.getMonth()+1;
	month = month < 10 ? '0'+month : month;
	let day = date.getDate();
	day = day < 10 ? '0'+day : day;
	return date.getFullYear()+'-'+month+'-'+day;
}
window.$getDateToday = () => {
	let fecha = new Date();
	let month = fecha.getMonth() + Number(1);
	let getDay = fecha.getDate();
	getDay = getDay < 10 ? '0'+getDay : getDay;
	month = month < 10 ? '0'+month : month;
	let today = fecha.getFullYear()+'-'+month+'-'+getDay;
	
	return today;
}
function Acceso( props ){
	const [ toggle, setToggle ] = React.useState(true);
	let modulo = props.match.params.modulo;
	let sesion = localStorage.getItem('sesion');
	sesion = JSON.parse(sesion);
	const moduloinventario = ( sesion.rol === '1' ? Inventarioadmin : Inventario );
	let destkop = {
		reportegeneral : Rgeneral,
		reportedecajas : ReporteDeCajas,
		dashboard : Dashboard,
		descuentos : Descuentos,
		productos : Productos,
		sucursales : Sucursales,
		reportes : Reportes,
		usuarios : Usuarios,
		inventario : moduloinventario,
		login : Login
		// egresos : Gastos
	};
	
	if( ! destkop.hasOwnProperty(modulo) ){
		props.history.push('/dashboard');
	}else{
		if( sesion === null || sesion.status === "fail"){
			props.history.push('/');
		}	
	}
	return(
		<div className="row full-width destkop">
			<aside className={`Menu ${ toggle ? 'xs-12 sm-3 md-2 lg-2' : 'xs-1 sm-1 md-1 lg-1 hideLeft'}`}>
				<Menu history={props.history} path={props.match.params.modulo} toggle={toggle}/>
				<svg 
					onClick={()=>setToggle(!toggle)}
					className={`toggleMenu ${ toggle ? '':'hideToggle'}`}
					stroke="currentColor" 
					fill="#fff" 
					strokeWidth="0"
					viewBox="0 0 16 16" 
					height="1em" width="1em"
				>
					<path fill='#769d28' d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"></path>
				</svg>
			</aside>
			<main className={`xs-12 ${ toggle ? 'sm-9 md-10 lg-10' : 'sm-11 md-11 lg-11'} no-padding`} style={{"overflow":"hidden"}}>
				<Header/>
				<div className="wrap">
					<Route exact path={"/"+modulo} component={destkop[modulo]} />
					<Route exact path="/reportes/:id" component={Reportes} />
				</div>
				{/* <Footer/> */}
			</main>
			<ToastContainer
               position="top-center"
               autoClose={4000}
               hideProgressBar
               newestOnTop
               closeOnClick
               rtl={false}
               draggable={false}
               pauseOnHover
         />
		</div>
	)
}
ReactDOM.render(
	<Router>
		<div>
			<Route exact path="/" component={Login}/>
			<Route path="/:modulo" component={Acceso} />
		</div>
	</Router>
,
  	document.getElementById('root')
);